import { isEmpty } from 'lodash';

export default class TranscriptArpabet {
  public static readonly AUTO_TRANSCRIPTION_INDICATOR: string = '-';
  public static readonly FLAGS: string[] = [
    'CAN_LINK',
    'MUST_LINK',
    'MUST_DROP'
  ];

  public static readonly ARPABET_SYMBOLS = [
    'AA0',
    'AA1',
    'AA2',
    'AE0',
    'AE1',
    'AE2',
    'AH0',
    'AH1',
    'AH2',
    'AO0',
    'AO1',
    'AO2',
    'AW0',
    'AW1',
    'AW2',
    'AY0',
    'AY1',
    'AY2',
    'B',
    'CH',
    'D',
    'DH',
    'DX_T',
    'DX_D',
    'EH0',
    'EH1',
    'EH2',
    'ER0',
    'ER1',
    'ER2',
    'EY0',
    'EY1',
    'EY2',
    'F',
    'G',
    'HH',
    'IH0',
    'IH1',
    'IH2',
    'IY0',
    'IY1',
    'IY2',
    'JH',
    'K',
    'L',
    'M',
    'N',
    'NG',
    'OW0',
    'OW1',
    'OW2',
    'OY0',
    'OY1',
    'OY2',
    'P',
    'R',
    'S',
    'SH',
    'T',
    'TH',
    'UH0',
    'UH1',
    'UH2',
    'UW0',
    'UW1',
    'UW2',
    'V',
    'W',
    'Y',
    'Z',
    'ZH',
    ''
  ];

  public static getSymbols() {
    let arpabet_symbols: string[] = [];
    TranscriptArpabet.ARPABET_SYMBOLS.map(function (el) {
      arpabet_symbols.push(el);
      arpabet_symbols.push('+' + el);
    });
    return arpabet_symbols;
  }

  public text?: string = undefined;
  public trans?: string[] = [];
  public flags?: string[] = [];

  public assign(response: any): TranscriptArpabet {
    if (response) {
      for (const key in response) {
        if (response.hasOwnProperty(key) && this.hasOwnProperty(key)) {
          (this as any)[key] = response[key];
        }
      }
    }

    return this;
  }

  /**
   *
   * @param value "[{"text": "User 1", "trans": [], "flags": []}, {"text": "User 2", "trans": [], "flags": []}]"
   * @returns
   */
  public static fromRaw(
    arpabetRaw: string,
    sentence: string
  ): TranscriptArpabet[] {
    try {
      const arpabets = JSON.parse(arpabetRaw);
      return arpabets.map((item) => {
        const trans = new TranscriptArpabet();
        trans.flags = item.flag;
        trans.text = item.text;
        trans.trans = item.trans;
        return trans;
      });
    } catch {
      console.log('Cannot parse JSON: ', arpabetRaw);
      if (isEmpty(sentence)) {
        return [];
      }

      const arpabet = new TranscriptArpabet();
      arpabet.text = sentence;
      arpabet.flags = [];
      arpabet.trans = [];
      return [arpabet];
    }
  }
}
